module.exports = __webpack_public_path__ + "static/media/details-10-image-2.ec89fcc1.jpg";